import React, { useEffect } from "react";
import moneyConvert from "utils/moneyConvert";
import * as S from "./style";
import useWindowSize, { Size } from "hooks/useWindowSize";

interface ArtNumberProps {
  data: {
    totalGpMoney: number;
    totalGpTransferedMoney: number;
    avgDateHold: number;
    avgProfit: number;
    totalGp: number;
    totalGpTransfered: number;
    avgYearProfit: number;
  };
}

function ArtNumber({ data }: ArtNumberProps) {
  const size: Size = useWindowSize();
  const isMobile = size.width && size.width <= 767;
  const [number, setNumber] = React.useState<typeof data>(data);

  useEffect(() => {
    const totalGpTransfered = (data?.totalGpTransfered / data?.totalGp) * 100;
    setNumber({ ...data, totalGpTransfered });
  }, [data]);

  return (
    <S.ArtNumber id="artnumber">
      <div className="title">청약 / 공동구매 현황</div>
      {isMobile ? (
        <>
          <div className="container">
            <div className="row">
              <span className="title">누적 모집 금액</span>
              <span className="num">
                {data?.totalGpMoney
                  ? moneyConvert(number?.totalGpMoney, true)
                  : 0}
                원
              </span>
            </div>
            <div className="row">
              <span className="title">누적 매각 금액</span>
              <span className="num">
                {number?.totalGpTransferedMoney
                  ? moneyConvert(number?.totalGpTransferedMoney, true)
                  : 0}
                원
              </span>
            </div>
            <div className="sum">
              <div className="row" style={{ width: "50%" }}>
                <span className="title">총 횟수</span>
                <div className="line1" />
                <span className="num">
                  {number?.totalGp ? moneyConvert(number?.totalGp, true) : 0}
                </span>
              </div>
              <div className="row" style={{ width: "50%" }}>
                <span className="title">매각율</span>
                <div className="line1" />
                <span className="num">
                  <span>
                    {number?.totalGpTransfered
                      ? moneyConvert(number?.totalGpTransfered, true)
                      : 0}
                  </span>
                  %
                </span>
              </div>
            </div>
            <div className="sum">
              <div className="row" style={{ width: "50%" }}>
                <span className="title">평균 투자 기간</span>
                <div className="line1" />
                <span className="num">
                  <span>
                    {number?.avgDateHold
                      ? moneyConvert(number?.avgDateHold, true)
                      : 0}
                  </span>
                  일
                </span>
              </div>
              <div className="row">
                <span className="title">
                  {/* 평균 수익률<span className="sub">(연평균)</span> */}
                  평균 수익률
                </span>
                <div className="line1" />
                <span className="num">
                  {number?.avgProfit
                    ? moneyConvert(number?.avgProfit, true)
                    : 0}
                  %
                  {/* <span className="sub">
                    (
                    {number?.avgYearProfit
                      ? moneyConvert(number?.avgYearProfit, true)
                      : 0}
                    %)
                  </span> */}
                </span>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="container-wrap">
          <div className="container">
            <div className="row">
              <span className="title">총 횟수</span>
              <div className="line1" />
              <span className="num">
                {number?.totalGp ? moneyConvert(number?.totalGp, true) : 0}
              </span>
            </div>
            <div className="row">
              <span className="title">누적 모집 금액</span>
              <div className="line2" />
              <span className="num">
                {number?.totalGpMoney
                  ? moneyConvert(number?.totalGpMoney, true)
                  : 0}
                원
              </span>
            </div>
            <div className="row">
              <span className="title">
                {/* 평균 수익률<span className="sub">(연평균)</span> */}
                평균 수익률
              </span>
              <div className="line1" />
              <span className="num">
                {number?.avgProfit ? moneyConvert(number?.avgProfit, true) : 0}%
                {/* <span className="sub">
                  (
                  {number?.avgYearProfit
                    ? moneyConvert(number?.avgYearProfit, true)
                    : 0}
                  %)
                </span> */}
              </span>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <span className="title">매각율</span>
              <div className="line1" />
              <span className="num">
                <span>
                  {number?.totalGpTransfered
                    ? moneyConvert(number?.totalGpTransfered, true)
                    : 0}
                </span>
                %
              </span>
            </div>
            <div className="row">
              <span className="title">누적 매각 금액</span>
              <div className="line2" />
              <span className="num">
                {number?.totalGpTransferedMoney
                  ? moneyConvert(number?.totalGpTransferedMoney, true)
                  : 0}
                원
              </span>
            </div>
            <div className="row">
              <span className="title">평균 투자 기간</span>
              <div className="line1" />
              <span className="num">
                <span>
                  {number?.avgDateHold
                    ? moneyConvert(number?.avgDateHold, true)
                    : 0}
                </span>
                일
              </span>
            </div>
          </div>
        </div>
      )}
    </S.ArtNumber>
  );
}

export default ArtNumber;
